import { create } from 'zustand';

export const TOP_NAVBAR_HEIGHT = 107;
export const BOTTOM_STICKY_HEIGHT = 68;

export const HEADER_HEIGHT_CSS = 'var(--header-height)';

interface LayoutState {
    /** Height reserved for a page's bottom sticky bar; some pages temporarily zero it out. */
    bottomStickyHeight: number;
    actions: {
        setBottomStickyHeight: (height: number) => void;
    };
}

export const useLayoutStore = create<LayoutState>()((set) => ({
    bottomStickyHeight: BOTTOM_STICKY_HEIGHT,
    actions: {
        setBottomStickyHeight: (height) => set({ bottomStickyHeight: height }),
    },
}));

export function getTopNavbarHeight(): number {
    if (typeof window === 'undefined') return TOP_NAVBAR_HEIGHT;
    const style = getComputedStyle(document.documentElement);
    return parseFloat(style.getPropertyValue('--top-navbar-height')) || TOP_NAVBAR_HEIGHT;
}

export function getHeaderHeight(): number {
    if (typeof window === 'undefined') return TOP_NAVBAR_HEIGHT;
    const style = getComputedStyle(document.documentElement);
    return (
        (parseFloat(style.getPropertyValue('--top-banner-height')) || 0) +
        (parseFloat(style.getPropertyValue('--top-navbar-height')) || TOP_NAVBAR_HEIGHT) +
        (parseFloat(style.getPropertyValue('--announcement-height')) || 0) +
        (parseFloat(style.getPropertyValue('--nv-banner-height')) || 0)
    );
}
